export class VideoCallJoinResult {
    constructor(externalId, sessionName) {
        this.externalId = externalId;
        this.sessionName = sessionName;
    }
}
